import { uiLoading2 } from './ui';
import { types } from '../types/types';
import { basicMsg, htmlMsg, msg as swalMsg, posMsg } from './swal_msg';

import { logout } from './user';
import { generateURL } from '../helpers/admin/productHelper';
import { checkUserSession } from '../helpers/admin/sessionHelper';
import {
    axiosProtectedReq,
    protectedAxiosReq,
    protectedFormReq,
    protectedReq
} from '../helpers/requestHelper';

import { variantInit2 } from '../constants/constants';

const showOdooValidationError = (body, title) => {
    const messages = [
        'invalid-odoo-id',
        'invalid-sync-odoo-stock',
        'odoo-id-required',
        'odoo-id-not-found',
        'duplicate-odoo-id',
        'odoo-catalog-unavailable'
    ];

    if (!messages.includes(body.msg))
        return false;

    swalMsg(
        'warning',
        title,
        body.resp?.message || 'No fue posible validar la vinculación con Odoo.'
    );
    return true;
};

export const loadProductMinList = () => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq('product/min-list');
            const body = await resp.json();
            if (body.status)
                dispatch(productMinListLoaded(body.resp.products));
            else {
                const { msg } = body;
                if (checkUserSession(msg)) { // sesión activa
                    if (msg === 'server-err')
                        swalMsg('error', 'Lista de productos',
                        'Ocurrió un incidente. Intente de nuevo, por favor');
                } else // cerrar sesión
                    dispatch(logout());
            }
        } catch (err) {
            basicMsg('No se pueden mostrar los productos');
        };
    };
};

// cargar lista de productos (módulo admin)
export const loadProductList = () => {
    return async(dispatch) => {
        dispatch(productListLoading(true));
        try {
            const resp = await protectedReq('product/list');
            const body = await resp.json();
            if (body.status)
                dispatch(productListLoaded(body.resp));
            else {
                const { msg } = body;
                if (checkUserSession(msg)) { // sesión activa
                    if (msg === 'server-err')
                        swalMsg('error', 'Lista de productos',
                        'Ocurrió un incidente. Intente de nuevo, por favor');
                } else // cerrar sesión
                    dispatch(logout());
            }
        } catch (err) {
            swalMsg('error', 'Lista de productos',
            'No se puede mostrar la lista de productos');
        } finally {
            dispatch(productListLoading(false));
        }
    };
};

export const loadProductDrafts = () => {
    return async(dispatch) => {
        dispatch({ type: types.productDraftsLoading, payload: true });
        try {
            const resp = await protectedReq('product/drafts');
            const body = await resp.json();
            if (body.status) {
                dispatch({
                    type: types.productDraftsLoaded,
                    payload: body.resp.drafts || []
                });
            } else if (!checkUserSession(body.msg)) {
                dispatch(logout());
            }
        } catch (err) {
            swalMsg(
                'error',
                'Borradores',
                'No se pudo cargar la lista de borradores'
            );
        } finally {
            dispatch({ type: types.productDraftsLoading, payload: false });
        }
    };
};

export const renewProductDraft = draftId => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq(
                `product/drafts/${draftId}/renew`,
                {},
                'PATCH'
            );
            const body = await resp.json();
            if (body.status) {
                dispatch({
                    type: types.productDraftUpdated,
                    payload: body.resp.draft
                });
                posMsg('success', 'Vigencia renovada por 30 días');
            } else {
                swalMsg('warning', 'Borradores', 'No se pudo renovar la vigencia');
            }
            return body;
        } catch (err) {
            swalMsg('error', 'Borradores', 'No se pudo renovar la vigencia');
            return { status: false, msg: 'request-err' };
        }
    };
};

export const discardProductDraft = draftId => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq(
                `product/drafts/${draftId}`,
                {},
                'DELETE'
            );
            const body = await resp.json();
            if (body.status) {
                dispatch({
                    type: types.productDraftDeleted,
                    payload: draftId
                });
                posMsg('success', 'Borrador descartado');
            } else {
                swalMsg('warning', 'Borradores', 'No se pudo descartar el borrador');
            }
            return body;
        } catch (err) {
            swalMsg('error', 'Borradores', 'No se pudo descartar el borrador');
            return { status: false, msg: 'request-err' };
        }
    };
};

export const setProductCatalogStatus = (productId, action) => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq(
                `product/${productId}/${action}`,
                {},
                'PATCH'
            );
            const body = await resp.json();
            if (body.status) {
                dispatch(updated(body.resp.product));
                posMsg(
                    'success',
                    action === 'archive'
                        ? 'Producto retirado de la tienda'
                        : 'Producto restaurado en la tienda'
                );
            } else {
                swalMsg(
                    'warning',
                    'Producto',
                    action === 'archive'
                        ? 'No se pudo retirar el producto'
                        : 'No se pudo restaurar el producto'
                );
            }
            return body;
        } catch (err) {
            swalMsg('error', 'Producto', 'No se pudo actualizar su estado');
            return { status: false, msg: 'request-err' };
        }
    };
};

// cargar lista con info básica de productos
const productMinListLoaded = (payload) => ({
    type: types.productMinListLoaded, payload
});
// cargar lista de productos
const productListLoaded = (payload) => ({
    type: types.productListLoaded, payload
});
const productListLoading = (payload) => ({
    type: types.productListLoading, payload
});

const remoteImage = image => ({
    id: image.id,
    name: image.name || image.id,
    alt: image.alt || ''
});

const draftRequestData = (Model, fbt_item = []) => {
    const {
        pos,
        category,
        subcategory,
        reviews,
        additional_images,
        variants,
        ...product
    } = Model;
    const localAdditionalImages = (additional_images || []).filter(
        image => image instanceof File
    );
    const draftVariants = (variants || []).map(variant => {
        const { key, images, ...data } = variant;
        return {
            ...data,
            draft_variant_id: variant.draft_variant_id || undefined,
            images: (images || [])
                .filter(image => image?.id)
                .map(remoteImage)
        };
    });
    const localVariantImages = (variants || []).map(variant =>
        (variant.images || []).filter(image => image?.img instanceof File)
    );

    return {
        payload: {
            ...product,
            fbt_item,
            variants: draftVariants,
            additional_images: (additional_images || [])
                .filter(image => image?.id)
                .map(remoteImage),
            has_pending_images: localAdditionalImages.length > 0
                || localVariantImages.some(images => images.length > 0)
        },
        localAdditionalImages,
        localVariantImages
    };
};

const uploadDraftImageGroup = async(draftId, data) => {
    if (data.files.length === 0)
        return { status: true };

    const form = new FormData();
    form.append('kind', data.kind);
    if (data.draftVariantId)
        form.append('draft_variant_id', data.draftVariantId);
    form.append('alt_array', JSON.stringify(data.files.map(
        image => image.alt || ''
    )));
    data.files.forEach(image => form.append(
        'images',
        image.img || image
    ));
    const resp = await protectedFormReq(
        `product/drafts/${draftId}/images`,
        form
    );
    return resp.json();
};

export const getProductDraft = async draftId => {
    const resp = await protectedReq(`product/drafts/${draftId}`);
    return resp.json();
};

export const saveProductDraft = async(Model, fbt_item, draftId = '') => {
    const {
        payload,
        localAdditionalImages,
        localVariantImages
    } = draftRequestData(Model, fbt_item);
    const resp = await protectedReq(
        draftId ? `product/drafts/${draftId}` : 'product/drafts',
        payload,
        draftId ? 'PUT' : 'POST'
    );
    let body = await resp.json();
    if (!body.status)
        return body;

    let savedDraft = body.resp.draft;
    const uploads = [{
        kind: 'additional',
        files: localAdditionalImages.map(file => ({ img: file, alt: '' }))
    }];
    localVariantImages.forEach((files, index) => uploads.push({
        kind: 'variant',
        draftVariantId: savedDraft.variants?.[index]?.draft_variant_id,
        files
    }));

    for (const upload of uploads) {
        body = await uploadDraftImageGroup(savedDraft._id, upload);
        if (!body.status) {
            return {
                ...body,
                resp: {
                    ...body.resp,
                    draft: savedDraft
                }
            };
        }
        savedDraft = body.resp?.draft || savedDraft;
    }
    return getProductDraft(savedDraft._id);
};

export const deleteProductDraftImage = async(draftId, fileId) => {
    const resp = await protectedReq(
        `product/drafts/${draftId}/images/${fileId}`,
        {},
        'DELETE'
    );
    return resp.json();
};

export const publishProductDraft = async draftId => {
    const resp = await protectedReq(
        `product/drafts/${draftId}/publish`,
        {},
        'POST'
    );
    return resp.json();
};

// añadir producto y variantes
export const addProduct = (Model, navigate) => {
    return async(dispatch) => {
        try {
            dispatch(uiLoading2(true));

            // retiramos la propiedad 'pos'
            const { pos, additional_images, variants, ...ProductModel } = Model;

            let imagesArr = []; // imágenes de variantes
            let messages = []; // mensajes de respuesta

            // separamos archivos de imágenes de variante
            const VariantModel = variants.map(v => {
                // retiramos propiedad 'key' e 'images'
                const { key, images, ...variant } = v;
                imagesArr.push(images);
                return variant;
            });
            const resp = await protectedReq('product/add', {
                ...ProductModel, variants: VariantModel // actualizamos modelo
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                const { product, html } = body.resp;
                const { imagesFolderId, prod_variants } = product;

                let variantImgs = []; // datos de variantes con imágenes
                if (prod_variants.length > 0) {
                    // datos e imágenes de variantes
                    prod_variants.forEach(({ _id, folderId }, i) => {
                        if (folderId)
                            variantImgs.push({
                                _id, folderId,
                                files: imagesArr[i] // incluimos imágenes para subida
                            });
                    });
                    // envío de imágenes a backend para subida
                    const messages1 = await uploadVariantsImages(variantImgs, dispatch);
                    messages = [...messages, ...messages1];
                    if (imagesFolderId) {
                        const { msg: messages2 } = await uploadProductImages(product, additional_images);
                        messages = [...messages, ...messages2];
                    }
                }
                // mensajes de backend
                let txt = '';
                for (const e of html) {
                    txt += `<li>${e}</li>`;
                };
                for (const e of messages) {
                    txt += `<li>${e}</li>`;
                };
                const icon = txt === '' ? 'success' : 'info';

                dispatch(uiLoading2(false));

                htmlMsg(icon, 'Producto registrado',
                `<div style="text-align: left; padding-left: 0pt;"><ul>
                ${txt}</ul></div>`);
                navigate('/nefro-admin/productos');
            } else {
                dispatch(uiLoading2(false));

                const { msg, resp } = body;
                if (checkUserSession(msg)) { // sesión activa
                    if (showOdooValidationError(body, 'Vinculación con Odoo'))
                        return;
                    else if (msg === 'miss')
                        basicMsg('Falta información del producto');
                    else if (msg === 'product-exists')
                        basicMsg('Producto ya se encuentra registrado');
                    else if (msg === 'server-err')
                        swalMsg('warning', 'Incidente al guardar producto',
                        'Intente de nuevo, por favor');
                    else {
                        if (resp.html && resp.html.length > 0)
                            htmlMsg('warning', 'Producto no registrado',
                            `<div style="text-align: left; padding-left: 0pt;"><ul>${
                                resp.html.map(e => e)
                            }</ul></div>`);
                        else
                            basicMsg('Producto no registrado');
                    }
                } else // cerrar sesión
                    dispatch(logout());
            }
        } catch (err) {
            dispatch(uiLoading2(false));
            swalMsg('error', 'Producto',
            'No se pudo registrar el producto');
        };
    };
};

// subir imágenes de variantes al registrar producto
const uploadVariantsImages = async (variants, dispatch) => {
    // variantes e imágenes
    let messages = [];
    const data = new FormData();
    variants.forEach(({ _id, folderId, files }, index) => {
        // Agregamos imágenes con campo único por producto
        files.forEach(({ img, alt }) => {
            data.append(`products[${index}][images][]`, img);
            data.append(`products[${index}][alt][]`, alt);
        });

        // Agregamos otros datos del producto
        data.append(`products[${index}][_id]`, _id);
        data.append(`products[${index}][folderId]`, folderId);
    });
    const body = await protectedAxiosReq(
        'product/variant-image-uploads', data, 'POST', dispatch
    );
    if (body) {
        const { status, msg, resp } = body;
        if (status)
            messages = [...messages, ...resp.messages];
        else
            messages = [...messages, msg];
    } else messages = [...messages, 'Error en la petición para subida de imágenes de variantes'];
    return messages;
};

// subir imágenes adicionales de producto
const uploadProductImages = async ({ _id, imagesFolderId }, images) => {
    const data = new FormData();
    data.append('product_id', _id);
    data.append('folderId', imagesFolderId);
    images.forEach(img => {
        data.append('file', img);
    });
    const url = 'product/additional-images-upload';
    try {
        const body = await axiosProtectedReq(url, data, 'POST');
        if (body.status)
            return body.resp;
        else
            return {
                msg: ['Incidente en petición para subida de imágenes adicionales'],
                imagesId: []
            };
    } catch (err) {
        return {
            msg: ['Error al realizar petición para subida de imágenes adicionales'],
            imagesId: []
        };
    };
};

// subir imágenes de variante en edición
const appendVariantImages = async (dispatch, model, newImages) => {
    const { folderId, title, prod_id, _id } = model;
    const data = new FormData();
    data.append('folderId', folderId);
    data.append('title', title);
    data.append('prod_id', prod_id);
    data.append('var_id', _id);
    data.append('alt_array', JSON.stringify(newImages.map(({ alt }) => alt)));
    data.append('pos_array', JSON.stringify(
        newImages.map((_, index) => model.images.length + index)
    ));
    newImages.forEach(({ img }) => {
        data.append('file', img);
    });

    try {
        const body = await axiosProtectedReq(
            'product/variant/images-append', data, 'POST'
        );
        const resp = body && body.resp ? body.resp : {};
        const messages = resp.messages || (body && body.msg ? [body.msg] : []);

        if (body && body.status) {
            dispatch(v_updated({
                ...model,
                folderId: resp.folderId || folderId,
                images: [...model.images, ...(resp.images || [])]
            }));

            if (messages.length === 0)
                posMsg('success', 'Variante actualizada. Imágenes subidas');
            else
                htmlMsg('warning', 'Imágenes de variante',
                `<div style="text-align: left; padding-left: 0pt;"><ul>${
                    messages.map(e => `<li>${e}</li>`).join('')
                }</ul></div>`);
        } else {
            htmlMsg('warning', 'Imágenes de variante',
            `<div style="text-align: left; padding-left: 0pt;"><ul>${
                messages.map(e => `<li>${e}</li>`).join('')
            }</ul></div>`);
        }
    } catch (err) {
        swalMsg('error', 'Imágenes de variante',
        'Error al enviar imágenes');
    };
};

// subir imágenes de nueva variante
const uploadVariantImages = async ({ _id, folderId }, images) => {
    const data = new FormData();
    data.append('folderId', folderId);
    data.append('_id', _id);
    data.append('alt_array', JSON.stringify(images.map(({ alt } ) => alt)));
    // for (const image of images) {
    //     data.append('file', image.img);
    // };
    images.forEach(({ img }) => {
        data.append('file', img);
    });
    const url = 'product/variant/images-upload';
    try {
        const body = await axiosProtectedReq(url, data, 'POST');
        if (body.status)
            return body.resp;
        else {
            if (body.msg === 'server-err')
                swalMsg('error', 'Subida de imágenes',
                'Problema con servidor');
            else if (body.msg === 'request-err')
                swalMsg('error', 'Subida de imágenes',
                'Problema con servidor');
            else
                swalMsg('warning', 'Nueva variante',
                'Incidente al subir imágenes');
            return [];
        }
    } catch (err) {
        swalMsg('error', 'Nueva variante',
        'Error al enviar imágenes');
        return [];
    };
};

// editar producto
export const productEdit = () => ({ type: types.productEdit });

// producto activo
export const productActive = (obj) => ({
    type: types.productActive,
    payload: obj
});

// producto ya no está siendo editado
export const productCloseModal = () => ({ type: types.productCloseModal });

// actualizar producto
export const productUpdate = (
    product, allCategories, additionalImages, deletedImages,
    { setDeletedImages, setAdditionalImages, setLoading }
) => {
    return async(dispatch) => {
        try {
            let moreImages = []; // nuevas imágenes adicionales
            const { _id, images } = product;
            // filtrar categorías/subcategorías seleccionadas
            const prod_category = allCategories.filter(e => e.checked).map(
                ({ category, url, subcategories }) => ({
                    category, url, subcategories: subcategories.filter(a => a.checked).map(
                        ({subcategory }) => subcategory
                    )
                })
            );
            const resp = await protectedReq('product/update', { ...product, prod_category, deletedImages }, 'PUT');
            const body = await resp.json();
            if (body.status) {
                const { html, folderId, revFolderId, imagesFolderId } = body.resp;
                let messages = [...html];

                if (additionalImages.length > 0) {
                    if (imagesFolderId) {
                        const { msg: messages1, imagesId } = await uploadProductImages(
                            { _id, imagesFolderId },
                            additionalImages
                        );
                        messages = [...messages, ...messages1];
                        moreImages = [...moreImages, ...imagesId];
                    } else messages = [...messages, '<li>Carpeta para imágenes adicionales no existe. Imágenes no se subirán</li>'];
                }
                let txt = '';
                for (const e of messages) {
                    txt += e;
                };
                if (txt !== '')
                    htmlMsg('info', 'Producto actualizado',
                    `<div style="text-align: left; padding-left: 0pt;"><ul>${
                        txt
                    }</ul></div>`);
                else
                posMsg('success', 'Producto actualizado');
                // actualizar valores de variante
                dispatch(updated({
                    ...product,  images: [...images, ...moreImages],
                    folderId, revFolderId, imagesFolderId
                }));
                setDeletedImages([]);
                setAdditionalImages([]);
            } else {
                if (body.msg === 'product-not-found')
                    basicMsg('No se encontró el producto');
                else if (body.msg === 'not-updated')
                    swalMsg('warning', 'Actualización',
                    'No se actualizó el producto');
                else if (body.msg === 'server-err')
                    swalMsg('error', 'Actualización producto',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else swalMsg('warning', 'Actualización producto',
                    'Inténtelo de nuevo, por favor');
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            swalMsg('error', 'Actualización',
            'No se pudo actualizar el producto');
        };
    };
};

// producto fue actualizado
const updated = (obj) => ({
    type: types.productUpdated,
    payload: obj
});

// mostrar variantes de producto seleccionado
export const activeVariants = (obj) => ({
    type: types.activeVariants,
    payload: obj
});

// editar variante
export const variantEdit = (obj) => ({
    type: types.variantEdit,
    payload: obj
});

// añadir variante de producto
export const addVariant = (
    prod_id, mainFolderId, model, batches, { setOpenVariantDialog, setValues }
) => {
    return async(dispatch) => {
        try {
            const { images, ...obj } = model;
            const resp = await protectedReq('product/variant/add',
                { ...obj, prod_id, mainFolderId, batches }, 'POST');
            const body = await resp.json();
            if (body.status) {
                const { _id, folderId } = body.resp;
                // envío de imágenes a backend para subida
                const variant_images = await uploadVariantImages({ _id, folderId }, images);
                dispatch(v_saved({
                    ...obj, _id, folderId, images: variant_images, batches
                }));
                setOpenVariantDialog(false); // cerrar diálogo
                setValues(variantInit2); // restablecer valores
            } else {
                const title = 'Nueva variante';
                if (showOdooValidationError(body, title))
                    return;
                else if (body.msg === 'server-err')
                    swalMsg('warning', title,
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else if (body.msg === 'variant-not-saved')
                    swalMsg('warning', title,
                    'La variante de producto no fue guardada');
                else if (body.msg === 'product-not-saved')
                    swalMsg('warning', title,
                    'La variante de producto no fue guardada');
                else if (body.msg === 'not-found')
                    swalMsg('warning', title,
                    'No se encontró el producto');
                else if (body.msg === 'folder-not-created')
                    swalMsg('warning', title,
                    'La carpeta de la variante no fue creada');
                else swalMsg('error', title,
                    'Inténtelo de nuevo, por favor');
            }
        } catch (err) {
            swalMsg('error', 'Nueva variante',
            'No se pudo registrar la variante');
        };
    };
};

// actualizar variante
export const variantUpdate = (model, newImages, deletedImages, _batches) => {
    return async(dispatch) => {
        try {
            const { batches, title, prod_id, ...variant } = model;
            const resp = await protectedReq('product/variant/update',
                { ...variant, deletedImages, _batches }, 'PUT');
            const body = await resp.json();
            if (body.status) {
                const savedVariant = body.resp ?
                    { ...variant, ...body.resp }
                :
                    variant;

                if (newImages.length > 0) // envío de nuevas imágenes de variante a backend para subida
                    await appendVariantImages(
                        dispatch,
                        {
                            ...savedVariant, title, prod_id,
                            batches: [...batches, ..._batches]
                        },
                        newImages
                    );
                else {
                    posMsg('success', 'Variante actualizada');
                    dispatch(v_updated({
                        ...savedVariant,
                        batches: [...batches, ..._batches]
                    }));
                }
            } else {
                if (showOdooValidationError(body, 'Variante'))
                    return;
                else if (body.msg === 'not-found')
                    swalMsg('warning', 'Variante',
                    'No se encontró la variante');
                else if (body.msg === 'not-updated')
                    swalMsg('warning', 'Variante',
                    'No se actualizó la variante');
                else if (body.msg === 'server-err')
                    swalMsg('error', 'Variante',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else swalMsg('warning', 'Variante',
                    'Inténtelo de nuevo, por favor');
            }
        } catch (err) {
            swalMsg('error', 'Variante',
            'No se pudo actualizar la variante');
        };
    };
};

// eliminar variante
export const variantDelete = (model) => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq('product/variant/delete', model, 'DELETE');
            const body = await resp.json();
            if (body.status) {
                if (body.msg === 'prod-not-upd')
                    swalMsg('success', 'Variante',
                    'Variante eliminada. Producto no actualizado');
                else posMsg('success', 'Variante e imágenes eliminadas');
               dispatch(v_deleted(model._id));
            } else {
                if (body.msg === 'not-found')
                    swalMsg('error', 'Variante',
                    'No se encontró la variante');
                else if (body.msg === 'not-deleted')
                    swalMsg('error', 'Variante',
                    'No se pudo eliminar la variante');
                else if (body.msg === 'server-err')
                    swalMsg('error', 'Variante',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else swalMsg('warning', 'Variante',
                    'Inténtelo de nuevo, por favor');
            }
        } catch (error) {
            basicMsg('No se pudo eliminar la variante');
        }
    }
};

// variante guardada en BD, agregar a arreglo en producto
const v_saved = (payload) => ({
    type: types.variantSaved, payload
});

// variante fue actualizada
const v_updated = (obj) => ({
    type: types.variantUpdated,
    payload: obj
});

// variante fue eliminada
const v_deleted = (id) => ({
    type: types.variantDeleted,
    payload: id
});

// variante ya no está siendo editada
export const variantCloseModal = () => ({ type: types.variantCloseModal });

// abrir snackbar en módulo de productos
// const productSnackbarOpen = () => ({
//     type: types.productSnackbarOpen
// });

// cerrar snackbar en módulo de productos
export const productSnackbarClose = () => ({
    type: types.productSnackbarClose
});

// abrir menú de producto en lista
export const setMenuAnchorEl = (obj) => ({
    type: types.productMenuAnchorEl,
    payload: obj
});

// registrar producto
export const productDefault = () => ({ type: types.productDefault });

// carga masiva de productos provenientes de .xlsx
export const massiveLoad = async(array) => {
    try {
        const filtered = array.filter(e => e.se_puede_vender === 'SI');
        const products = filtered.map(({
            id, categorias, titulo, titulo_variante, precio_no_iva, iva,
            stock, clave_sat, codigo_barras, info, claveUnidad,
            unidad, palabras_clave, destacado, descripcion, disponible,
            id_odoo, sincronizar_inventario_odoo
        }) => {
            const title = titulo ? titulo : '';
            // categorías extras
            const categories = categorias ? categorias.split(',').map(e => e.trim()) : [];
            return {
                id: id ? id : '',
                title,
                url: generateURL(title),
                variant_title: titulo_variante ? titulo_variante : '',
                price: precio_no_iva ? precio_no_iva : 0,
                iva: iva ? iva : 0,
                stock: stock ? stock : 0,
                info: info ? info : '',
                sat_key: clave_sat ? clave_sat : '',
                claveUnidad: claveUnidad ? claveUnidad : '',
                unidad: unidad ? unidad : '',
                barcode: codigo_barras ? codigo_barras : '',
                category: categories,
                description: descripcion ? descripcion : 'Sin descripción',
                keywords: palabras_clave ? palabras_clave.split(',').map(e => e.trim()): [],
                odoo_id: id_odoo ? id_odoo : '',
                sincronizar_inventario_odoo,
                featured: (['SI','Sí','Si'].includes(destacado)) ? true : false,
                available: (['SI','Sí','Si'].includes(disponible)) ? true : false
            }
        });
        const resp = await protectedReq('product/massive-load', products, 'POST');
        const body = await resp.json();
        if (body.status) {
            const { registered, failed } = body.resp;
            // const { _inserted, _updates, failed_insertions, failed_updates } = body.resp;
            // const failMsg = failed_insertions > 0 ? `Productos no registrados: ${failed_insertions}` : 'Sin errores en registro de productos';
            // const failMsg2 = failed_updates > 0 ? `Productos no actualizados: ${failed_updates}` : 'Sin errores en actualización de productos';
            // htmlMsg('success', 'Carga masiva',
            // `<p>Carga masiva finalizada</p><h5>Resumen de carga:</h5>
            // <h6>Productos registrados: ${_inserted}</h6>
            // <h6>Productos actualizados: ${_updates}</h6>
            // <h6>${failMsg}</h6>
            // <h6>${failMsg2}</h6>`);
            htmlMsg('success', 'Carga masiva',
                `<p>Carga masiva finalizada</p><h5>Resumen de carga:</h5>
                <h6>Productos registrados: ${registered.length}</h6>
                <h6>Operaciones fallidas: ${failed.length}</h6>`
            );
        } else if (!showOdooValidationError(body, 'Carga masiva'))
            swalMsg(
                'error',
                'Carga masiva',
                'Ocurrió un incidente. Intente de nuevo, por favor'
            );
        return body.status;
    } catch (err) {
        swalMsg('error', 'Carga masiva',
        'No se pudo hacer carga masiva de productos');
        return false;
    }
};
